import { useEffect, useState } from 'react';

interface UseCostProps {
  model: string;
  resolution: string;
  duration: string;
  variations: string;
  imageUrl?: string | null;
  imageUrls?: string[];
}

export function useCost({
  model,
  resolution,
  duration,
  variations,
  imageUrl,
  imageUrls,
}: UseCostProps) {
  const [services, setServices] = useState<any[]>([]);

  // Fetch Services for dynamic pricing
  useEffect(() => {
    const loadServices = async () => {
      try {
        const { getServicesAction } = await import('@/server/actions/service-actions');
        const result = await getServicesAction();
        if (result.success && result.data) {
          setServices(result.data);
        }
      } catch (error) {
        console.error('Failed to load services for pricing', error);
      }
    };
    loadServices();
  }, []);

  const getDynamicCost = () => {
    let slug = '';
    if (model === 'elevenlabs-sfx') {
      slug = 'elevenlabs-sfx';
    } else if (model === 'nano-banana-2') {
      // Nano Banana slugs don't include duration: e.g. nano-banana-2-1K
      slug = `nano-banana-2-${resolution}`;
    } else if (model === 'z-image') {
      slug = 'z-image';
    } else if (model === 'runway') {
      const res = resolution === '1080p' ? '1080p' : '720p';
      let dur = duration;
      if (dur !== '5s' && dur !== '10s' && dur !== '15s') dur = '5s';
      slug = `runway-${res}-${dur}`;
    } else if (model === 'grok-imagine') {
      const res = resolution === '720p' ? '720p' : '480p';
      let dur = duration;
      if (dur !== '6s' && dur !== '10s' && dur !== '15s') dur = '6s';
      slug = `grok-${res}-${dur}`;
    } else {
      // Construct slug: e.g. sora-2-720p-10s
      const durationSlug = duration === '5s' ? '10s' : duration;
      slug = `${model}-${resolution}-${durationSlug}`;
    }

    const service = services.find((s) => s.slug.toLowerCase() === slug.toLowerCase());

    // If services haven't loaded yet, return null to indicate "calculating..."
    if (services.length === 0) return null;

    return service ? service.creditCost : 35; // Fallback only if services loaded but matching logic fails
  };

  const COST_PER_VIDEO = getDynamicCost();
  const estimatedCost =
    COST_PER_VIDEO !== null ? COST_PER_VIDEO * Number.parseInt(variations) : null;

  return {
    services,
    estimatedCost,
    COST_PER_VIDEO,
  };
}
